exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".insert-role[data-v-2ec714c4] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.form-check-input[data-v-2ec714c4],\n.form-check-label[data-v-2ec714c4] {\n  cursor: pointer;\n}\n", ""]);

// exports
